import React from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    Divider,
    Container
} from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import Icon from "@/theme/vectors/bundle";
import { ROUTES } from "@/utils/web/constants";

const OrderSuccess = ({ orderNumber }) => {
    const { t } = useTranslation();

    return (
        <Container maxWidth="md">
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    my: 4,
                    textAlign: "center",
                    borderRadius: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mb: 3
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: "success.light",
                            color: "success.contrastText",
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2
                        }}
                    >
                        <Icon name="check" size={40} />
                    </Box>

                    <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
                        {t("order.thankYou")}
                    </Typography>

                    <Typography variant="h6" color="text.secondary">
                        {t("order.successMessage")}
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 4 }}>
                    <Typography variant="body1" gutterBottom>
                        {t("order.orderNumber")}:
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        {orderNumber}
                    </Typography>
                </Box>
                {/*                 
                <Typography variant="body1" paragraph>
                    {t("order.confirmationSent")}
                </Typography>
                
                <Typography variant="body2" color="text.secondary" paragraph>
                    {t("order.trackingInfo")}
                </Typography> */}

                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
                    <Button
                        component={Link}
                        to={ROUTES.HOME}
                        variant="outlined"
                        size="large"
                    >
                        {t("common.backToHome")}
                    </Button>

                    <Button
                        component={Link}
                        to={ROUTES.PRODUCTS}
                        variant="contained"
                        size="large"
                    >
                        {t("common.continueShopping")}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default OrderSuccess; 